/**
 * localStorage的读取、写入和删除操作模块
 * @module Storage
 */
import { setCookie, getCookie, delCookie } from './tools'

const Storage = {
  avaliable () {
    try {
      const storage = window.localStorage;
      var x = '__storage_test__'
      storage.setItem(x, x)
      storage.removeItem(x)
      return true
    } catch (err) {
      console.log(err)
    }
    return false
  },
  save: (key, jsonData) => {
    if (Storage.avaliable()) {
      localStorage.setItem(key, JSON.stringify(jsonData))
    } else {
      setCookie(key, jsonData)
    }
    return jsonData
  },
  load: key => {
    let record = null
    try {
      if (Storage.avaliable()) {
        record = JSON.parse(localStorage.getItem(key))
      } else {
        record = JSON.parse(getCookie(key))
      }
    } catch (err) {}
    return record
  },
  remove: key => {
    if (Storage.avaliable()) {
      localStorage.removeItem(key)
    } else {
      delCookie('key')
    }
  },
  saveOnday: (key, jsonData, expirationDay = 15) => {
    // 默认缓存15天
    let expirationMS = expirationDay * 24 * 60 * 60 * 1000
    let record = {
      value: JSON.stringify(jsonData),
      timestamp: new Date().getTime() + expirationMS
    }
    Storage.save(key, record)
    return jsonData
  },
  saveOntime: (key, jsonData, expirationMinute = 30) => {
    // 默认缓存半个小时
    let expirationMS = expirationMinute * 60 * 1000
    let record = {
      value: JSON.stringify(jsonData),
      timestamp: new Date().getTime() + expirationMS
    }
    Storage.save(key, record)
    return jsonData
  },
  loadOntime: key => {
    let record = Storage.load(key)
    if (!record) {
      return false
    }
    return (
      new Date().getTime() < record.timestamp && JSON.parse(record.value)
    )
  }
}

export default Storage